/**
 * Test page at /speedtest: shows ASN (substituted by nginx) in large font for speedtest screenshots.
 */

export function SpeedtestPage() {
  const asn =
    typeof window !== "undefined"
      ? (window as any).__SPEEDTEST_ASN__
      : "__TEST_ASN__";

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#000",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
        boxSizing: "border-box",
      }}
    >
      <div style={{ fontSize: "clamp(2rem, 15vw, 8rem)", fontWeight: 700 }}>
        ASN: {asn}
      </div>
    </div>
  );
}
